import React from 'react';
import { makeStyles, Button, Typography } from '@material-ui/core';
import Refresh from '@material-ui/icons/Refresh';
var useStyles = makeStyles(function () { return ({
    root: {
        color: '#DE3131',
        paddingLeft: 0
    },
    icon: {
        color: '#0A5D91'
    }
}); });
export default function MetricCardError(_a) {
    var _b = _a.message, message = _b === void 0 ? 'Unable to load data' : _b, _c = _a.noReload, noReload = _c === void 0 ? false : _c, onClick = _a.onClick;
    var classes = useStyles();
    if (noReload) {
        return (React.createElement(Typography, { className: classes.root, variant: "button" }, message));
    }
    return (React.createElement(Button, { className: classes.root, endIcon: React.createElement(Refresh, { className: classes.icon }), onClick: onClick, variant: "text" }, message));
}
//# sourceMappingURL=MetricCardError.js.map